import PT from 'prop-types';
import * as analyticsConstants from 'edrolo/constants/Analytics';

const StaffRibbonLink = ({ title, url, analyticsPayload = {} }) => (
  <li>
    <a
      onClick={() =>
        global.analytics.track('clicked staff link', {
          origin: analyticsConstants.ORIGIN.STAFF_RIBBON,
          url,
          title,
          ...analyticsPayload,
        })
      }
      href={url}
      target="_blank"
      rel="noopener noreferrer"
    >
      {title}
    </a>
  </li>
);

StaffRibbonLink.propTypes = {
  title: PT.string.isRequired,
  url: PT.string.isRequired,
  analyticsPayload: PT.object,
};

export default StaffRibbonLink;
